import type { CollectionOfferGroup } from "@anaconda/core/nft-collection/collection/types"
import { Trans } from "@lingui/react/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { Count } from "../../view/count"
import { HeaderCell } from "./cells"
import { OfferMakers } from "./offer-makers"
import { OfferPrice, OfferTotalVolume } from "./offer-price"

interface Column {
  Header: React.ComponentType
  Content: React.ComponentType<{
    offerGroup: CollectionOfferGroup
    bestTotalVolume: string
  }>
  Skeleton: React.ComponentType
}

export const COLUMNS: Column[] = [
  {
    Header: () => (
      <HeaderCell className="w-[200px] md:w-[354px]">
        <Trans>Price</Trans>
      </HeaderCell>
    ),
    Content: ({ offerGroup, bestTotalVolume }) => (
      <OfferPrice offerGroup={offerGroup} bestTotalVolume={bestTotalVolume} />
    ),
    Skeleton: () => <Skeleton className="h-9 w-full" />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[90px]">
        <Trans>Size</Trans>
      </HeaderCell>
    ),
    Content: ({ offerGroup }) => <Count value={offerGroup.offersCount} />,
    Skeleton: () => (
      <div className="flex justify-end">
        <Skeleton className="h-6 w-[60px]" />
      </div>
    ),
  },
  {
    Header: () => (
      <HeaderCell className="w-[120px]">
        <Trans>Total</Trans>
      </HeaderCell>
    ),
    Content: ({ offerGroup }) => <OfferTotalVolume offerGroup={offerGroup} />,
    Skeleton: () => (
      <div className="flex justify-end">
        <Skeleton className="h-6 w-[80px]" />
      </div>
    ),
  },
  {
    Header: () => (
      <HeaderCell className="w-[140px]">
        <Trans>Users</Trans>
      </HeaderCell>
    ),
    Content: ({ offerGroup }) => <OfferMakers offerGroup={offerGroup} />,
    Skeleton: () => (
      <div className="flex justify-end">
        <Skeleton className="h-6 w-[108px]" />
      </div>
    ),
  },
]
